import { call, put, takeEvery, takeLatest, apply } from 'redux-saga/effects';
import { message } from 'antd';
import _ from 'lodash';
import { authUserError } from 'pages/AppLogin/action';
import { ADD_ONECLICK, EDIT_ONECLICK, LIST_ONECLICK, TOGGLE_DRAWER, TOGGLE_DELETE_MODAL } from './constant';
import { listOneclick as listOneclickAction, listOneclickSuccess, listOneclickError, addOneclickSuccess, addOneclickError, editOneclickSuccess, editOneclickError, toggleDrawer, toggleDeleteModal } from './action';
import { addOneclick, editOneclick, listOneclick } from 'services/oneclick';

export function* listOneclickSaga(action) {
  try {
    const res = yield call(listOneclick, action.payload);
    const oneclickData = JSON.parse(res.text);
    // console.log(oneclickData);
    yield put(
      listOneclickSuccess({
        total: oneclickData.oneclick.total,
        attributes: oneclickData.oneclick.oneclick.map((item) => ({
          ...item,
          key: item.oneclick_id,
        })),
      }),
    );
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(listOneclickError(err.response.text));
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(listOneclickError(err.response.text));
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* addOneclickSaga(action) {
  try {
    const res = yield call(addOneclick, action.payload);
    const userData = JSON.parse(res.text);
    yield put(addOneclickSuccess(userData.data));
    yield put(toggleDrawer());
    yield put(listOneclickAction({ page: 1, limit: 10 }));
    message.success(userData.data.message);
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(addOneclickError(err.response.text));
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 400)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError.message);
      yield put(addOneclickError());
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(addOneclickError(err.response.text));
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* editOneclickSaga(action) {
  try {
    const res = yield call(editOneclick, action.payload);
    const userData = JSON.parse(res.text);
    yield put(editOneclickSuccess(userData.data));
    yield put(toggleDrawer());
    yield put(listOneclickAction({ page: 1, limit: 10 }));
    message.success(userData.data.message);
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(editOneclickError());
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(editOneclickError());
    }
    if (_.isEqual(err.status, 409)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError.message);
      yield put(editOneclickError());
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* toggleDrawerSaga(action) {
  put(toggleDrawer());
}
export function* toggleDeleteModalSaga(action) {
  put(toggleDeleteModal());
}

export default function* OneclickSaga() {
  yield takeLatest(LIST_ONECLICK, listOneclickSaga);
  yield takeEvery(ADD_ONECLICK, addOneclickSaga);
  yield takeEvery(EDIT_ONECLICK, editOneclickSaga);
  yield takeEvery(TOGGLE_DRAWER, toggleDrawerSaga);
  yield takeEvery(TOGGLE_DELETE_MODAL, toggleDeleteModalSaga);
}
